module.exports = __webpack_public_path__ + "img/answerComplete.02b9763a.png";